import i18next from "i18next";
import {initReactI18next} from "react-i18next/initReactI18next";

import en from '../public/locales/en_US.json'
import zh from '../public/locales/zh_CN.json'
import zh_tw from '../public/locales/zh_TW.json'
import ja_jp from '../public/locales/ja_JP.json'
import de_de from '../public/locales/de_DE.json'
import {getSysConfig} from "@model/sysconfig";
import {SYS_CONFIG_KEY_LANGUAGE_CODE} from "@/Const";
import {isStringNullOrEmpty} from "@/utils";

export function initLanguage(){
    let langCode = localStorage.getItem(SYS_CONFIG_KEY_LANGUAGE_CODE);
    if (isStringNullOrEmpty(langCode)){
        langCode = getDefaultSystemLanguage();
        if (langCode?.startsWith('en')){
            langCode = 'en';
        }else if (langCode == 'zh-CN'){
            langCode = 'zh';
        }else if (langCode == 'zh-TW'){
            langCode = 'zh_tw'
        }else if (langCode?.includes('ja')){
            langCode = 'ja_jp'
        }else if (langCode?.includes('de')){
            langCode = 'de_de'
        }
        else{
            langCode = 'en';
        }
        localStorage.setItem(SYS_CONFIG_KEY_LANGUAGE_CODE,langCode);
    }
    i18next
        .use(initReactI18next).init({
        resources:{
            en,
            zh,
            zh_tw,
            ja_jp,
            de_de
        },
        fallbackLng:langCode,
        interpolation:{
            escapeValue:false
        }
    })
}

export function getLanguageCode(){
    let langCode = localStorage.getItem(SYS_CONFIG_KEY_LANGUAGE_CODE);
    return langCode;
}

function getDefaultSystemLanguage(){
    let lang;
    // 首先尝试获取浏览器语言
    if (navigator.language) {
        lang = navigator.language;
    } else {
        // 如果无法获取浏览器语言，则尝试获取系统语言
        lang = navigator.systemLanguage;
    }
    return lang;
}

export function switchLanguage(szLangCode){
    i18next.changeLanguage(szLangCode)
}

/**
 * 是否中文
 */
export function isZh(){
    var langCode = localStorage.getItem(SYS_CONFIG_KEY_LANGUAGE_CODE);
    return langCode?.startsWith("zh");
}



